import { Box } from "@mui/material";

import innovationstudio from "../assets/images/supporting_org/innovationstudio.svg";
import nvidia from "../assets/images/supporting_org/nvidia.svg";
import topcompany from "../assets/images/supporting_org/topcompany.svg";
import techstar from "../assets/images/supporting_org/techstart.svg";
import fundable from "../assets/images/supporting_org/fundable.svg";
import aws from "../assets/images/supporting_org/aws.svg";
import urbanite from "../assets/images/supporting_org/urbanite.svg";


const SupportingOrganizations = () => {

  const logos = [
    { src: innovationstudio, alt: 'Earth Rated', width: '100%' },
    { src: nvidia, alt: 'CSI Tech Incubator', width: '100%' },
    { src: topcompany, alt: 'Walkee Paws', width: '100%' },
    { src: techstar, alt: 'SuperZoo', width: '100%' },
    { src: fundable, alt: 'Brilliant Veterinary Care', width: '100%' },
    { src: aws, alt: 'Brilliant Veterinary Care', width: '100%' },
    { src: urbanite, alt: 'Brilliant Veterinary Care', width: '100%' },
    // { src: nextgen, alt: 'Nexxtgen', width: '100%' },
  ];

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        backgroundColor: 'black',
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexWrap: "nowrap",
          gap: 10,
          animation: "marquee 15s linear infinite",
          "@keyframes marquee": {
            "0%": { transform: "translateX(0)" },
            "100%": { transform: "translateX(-100%)" },
          },
        }}
      >
        {[
          ...logos,
          ...logos,
          ...logos,
          ...logos,
          ...logos].map((logo, index) => (
            <Box
              key={index}
              component="img"
              src={logo.src}
              alt={logo.alt}
              sx={{
                objectFit: "contain",
                width: {
                  xs: logo.width,
                  sm: logo.width,
                  md: logo.width,
                },
                height: "auto",
              }}
            />
          ))}
      </Box>
    </Box>
  );
};

export default SupportingOrganizations;


